<template>
  <div
    v-if="isBannerVisible"
    :class="[
      'fixed bottom-0 left-0 right-0 mx-auto flex z-30 rounded-xl bg-gradient-to-r from-primary-600 to-primary-700 text-white shadow-2xl border-t border-primary-500 transform transition-all duration-500 hover:scale-105 animate-bounce-subtle mb-4',
      isVerySmallScreen ? 'mx-3 max-w-[95%]' : (isMobile ? 'mx-auto max-w-[85%]' : 'mx-4 max-w-md')
    ]"
    @click.stop="openStore"
  >
    <div class="relative px-5 py-4 sm:px-4 w-full">
      <button
        @click.stop="isBannerVisible = false"
        class="absolute top-3 right-3 p-1 rounded-full hover:bg-white/20 transition-colors"
        aria-label="Cerrar banner"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>

      <div :class="[
        'flex items-center pr-3',
        isVerySmallScreen ? 'flex-col space-y-4 py-2' : (isMobile ? 'justify-center space-x-4' : 'justify-center space-x-4')
      ]">
        <div :class="[
          'flex-shrink-0',
          isVerySmallScreen ? 'self-center' : ''
        ]">
          <div class="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm pulse-effect">
            <svg class="w-7 h-7 fill-white" viewBox="0 0 24 24">
              <path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z"/>
            </svg>
          </div>
        </div>

        <div :class="[
          'min-w-0',
          isVerySmallScreen ? 'text-center' : 'flex-1'
        ]">
          <p class="text-sm font-semibold">¡Descarga nuestra app!</p>
          <p class="text-xs text-white/90 mt-0.5">
            Obtén la mejor experiencia en tu dispositivo
          </p>
        </div>

        <div :class="[
          'flex-shrink-0',
          isVerySmallScreen ? 'self-center mt-1' : ''
        ]">
          <button class="bg-white text-primary-600 px-3 py-1.5 rounded-full font-semibold text-sm hover:bg-white/90 transition-colors shadow-md">
            Descargar
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
const isBannerVisible = ref(true)
const runtimeConfig = useRuntimeConfig()
const router = useRouter()

const { isIos, isAndroid, isMobile } = useDevice()
const isVerySmallScreen = ref(false)

onMounted(() => {
  // Check if screen is very small (less than 375px)
  const checkScreenSize = () => {
    isVerySmallScreen.value = window.innerWidth < 375
  }

  // Initial check
  checkScreenSize()

  // Add event listener for resize
  window.addEventListener('resize', checkScreenSize)

  // Clean up
  onBeforeUnmount(() => {
    window.removeEventListener('resize', checkScreenSize)
  })
})

const getStoreUrl = () => {
  if (isIos) {
    return runtimeConfig.public?.applestoreUrl
  }
  else if (isAndroid) {
    return runtimeConfig.public?.playstoreUrl
  }

  return null
}

const openStore = () => {
  const storeUrl = getStoreUrl()
  if (storeUrl) {
    window.open(storeUrl, '_blank')
  } else {
    // If not iOS or Android, redirect to download page (for Mac/Windows)
    router.push('/download')
  }
}
</script>

<style scoped>
.pulse-effect {
  animation: pulse 2s infinite;
}
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}
</style>
